import { render, staticRenderFns } from "./TransferMatchModal.vue?vue&type=template&id=f8741cf0"
import script from "./TransferMatchModal.vue?vue&type=script&lang=js"
export * from "./TransferMatchModal.vue?vue&type=script&lang=js"
import style0 from "./TransferMatchModal.vue?vue&type=style&index=0&id=f8741cf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports